import { useRef } from "react"
import { ESectors } from "../../shared/Consts"
import TextInput, { Evaluators, ITextInput } from "../../gui/TextInput/TextInput"
import IconButton from "../../gui/Button/IconButton"
import PortUtils from "../../portlibs/PortUtils"
import DeleteIcon from "../../gui/Icons/DeleteIcon"
import _ from "lodash"

type TSectorRowProps = {
    sector:ESectors,
    value:number,
    onUpdate:(sector:ESectors,percent:number) => void
    onDelete:(sector:ESectors) => void
}
export default function SectorRow(props:TSectorRowProps) {
    const refPercent = useRef<ITextInput|null>(null)
    const percent = ((props.value||0)*100).toFixed(2)
    const onDelete = () => props.onDelete(props.sector)
    const onUpdate = (e:any) => refPercent.current && props.onUpdate(props.sector, parseFloat(refPercent.current.value!)/100)
    return <div className="row flex middle gap-8">
        <label className="flex1">{PortUtils.sector(props.sector)}</label>
        <TextInput ref={refPercent} defaultValue={percent} placeholder="Holding %" float={true} evaluator={Evaluators.Number} onBlur={onUpdate}/>
        <IconButton onClick={onDelete}><DeleteIcon/></IconButton>
    </div>
}